import { render, staticRenderFns } from "./StampForm.vue?vue&type=template&id=0fab4356&"
import script from "./StampForm.vue?vue&type=script&lang=js&"
export * from "./StampForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports